/*
 *
 * TransactionsDownloadAllPopup
 *
 * @version 1.0.0
 * @author Ivana Piscitelli
 * @since 16-Jun-2025
*/

import TransactionsDownloadAllPopup from './TransactionsDownloadAllPopupContainer'

export default TransactionsDownloadAllPopup
